import { useState, useEffect, useCallback } from 'react';
import { api, ContributorMetricsResult, ContributorMetricsSummary, ContributorEntityMetric } from '../../lib/api';

interface UseContributorMetricsReturn {
  summary: ContributorMetricsSummary | null;
  entities: ContributorEntityMetric[];
  loading: boolean;
  error: string | null;
  refresh: () => void;
}

export function useContributorMetrics(): UseContributorMetricsReturn {
  const [result, setResult] = useState<ContributorMetricsResult | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchMetrics = useCallback(async () => {
    setLoading(true);
    setError(null);

    try {
      const data = await api.getContributorMetrics();
      setResult(data);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Failed to fetch metrics');
      setResult(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchMetrics();
  }, [fetchMetrics]);

  return {
    summary: result?.summary ?? null,
    entities: result?.entities ?? [],
    loading,
    error,
    refresh: fetchMetrics,
  };
}
